<template>
  <div class="full-page" style="padding:35px 15px 15px 50px;" v-if="isShow">
    <div class="fix-middle-actions"><el-button circle size="mini" icon="el-icon-close" @click="close"></el-button></div>
    <div class="full-body" v-loading="loading">
      <el-table
        ref="table"
        v-loading="loading"
        :data="data"
        highlight-current-row
        class="flex-column"
        size="mini"
        border
      >
        <el-table-column type="index" align="center" width="50" />
        <el-table-column width="60" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showSheet(scope.row)">处理</el-button>
          </template>
        </el-table-column>
        <el-table-column label="文件名" prop="originalname" min-width="160"> </el-table-column>
        <el-table-column label="上传人" prop="uploader" width="120"> </el-table-column>
        <el-table-column label="上传时间" width="120">
          <template slot-scope="scope">{{ moment(scope.row.createdAt) }}</template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :current-page="page"
      :page-sizes="[100, 200, 500]"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChange"
      @current-change="pageChange"
      style="position:absolute;bottom:0;background:#fff"
    />
  </div>
</template>
<script>
const dateFormat = require('dateformat')
export default {
  data() {
    return {
      loading: false,
      isShow: false,
      data: [],
      page: 1,
      pageSize: 100,
      total: 0,
    }
  },
  methods: {
    open() {
      this.isShow = true
      this.loadData()
    },
    close() {
      this.isShow = false
    },
    moment(date) {
      return date ? dateFormat(new Date(parseInt(date, 10)), 'yyyy-mm-dd') : '--'
    },
    async loadData() {
      this.loading = true
      const res = await app.service('file').list({
        paginate: { page: this.page, pageSize: this.pageSize },
        query: { type: '最终list', isDeleted: { $ne: true } },
      })
      this.data = res.data
      this.total = res.data.length
      this.loading = false
    },
    pageSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    pageChange(val) {
      this.page = val
      this.loadData()
    },
    async showSheet(row) {
      const saveRes = await app.service('radish').addSheetsData({ file: row })
      if (saveRes.status === 'success') {
        const sheetId = saveRes.data.sheetId
        console.log
        const checkRes = await app.service('radish').excelCheck({ sheetId })
        if (checkRes.status === 'success') {
          app.root.$refs.ExcelCorrection.show({ records: checkRes.data, sheetId, type: 'list', fileMd5: row.md5 })
        }
      } else {
        this.$message.error('解析失败')
      }
    },
  },
}
</script>
